import { FormattedMessage } from 'react-intl';
import './index.scss';

const View = ({ isLoading }) => {
  return (
    <div className="coupon_content">
      <h3 className="title">
        <FormattedMessage id="MY_PAGE_ORG_MGMT" />
      </h3>
    </div>
  );
};

export default View;
